import React from 'react'
import { useEthers } from '../../hooks'
import { Currency } from '../../model'
import { StakingOption } from '../../pages/token/staking/utils'
import { getApproveTokenForDelayTx, getApproveTokenForStakingTx } from '../../transactions'
import { ApprovalButton } from './ApprovalButton'

interface DelayProps {
  currency: Currency
}

export function ApproveTokenForDelayButton({ currency }: DelayProps) {
  const { chainId } = useEthers()
  return (
    <ApprovalButton symbol={currency.symbol} transaction={chainId && getApproveTokenForDelayTx(currency, chainId)} />
  )
}

interface StakingProps {
  currency: Currency
  stakingOption: StakingOption
}

export function ApproveTokenForStakingButton({ stakingOption, currency }: StakingProps) {
  const { chainId } = useEthers()
  return (
    <ApprovalButton
      symbol={currency.symbol}
      transaction={chainId && getApproveTokenForStakingTx(currency, chainId, stakingOption)}
    />
  )
}
